import * as Yup from 'yup';
import { measurementTyes } from '../constants';

const lotValidationBase = {
  volume: Yup.number().required('The volume is required'),
  startDate: Yup.date().required('The start date is required')
};

export const lotValidationSchema = Yup.object().shape({
  ...lotValidationBase,
  productId: Yup.string().required('The product is required'),
  transferScheduleId: Yup.number().required('The transfer schedule is required')
});

export const lotCloneValidationSchema = Yup.object().shape({
  startDate: Yup.date().required('The start date is required')
});

export const lotMultipleValidationSchema = Yup.object().shape({
  volume: Yup.number().required('The volume is required'),
  startDate: Yup.date().required('The start date is required'),
  transferScheduleId: Yup.number().required('The transfer schedule is required'),
  products: Yup.array().of(
    Yup.object().shape({
      id: Yup.number().typeError('The product is required')
    })
  )
});

export const lotTransferDateChangeValidationSchema = Yup.object().shape({
  transferDate: Yup.date().required('The transfer date is required')
});

export const lotEditValidationSchema = Yup.object().shape({
  ...lotValidationBase,
  ingredients: Yup.array().of(
    Yup.object().shape({
      ingredientId: Yup.number().required('The ingredient is required'),
      amount: Yup.number().required('The ingredient amount is required'),
      measurementType: Yup.string()
        .oneOf(measurementTyes, 'The unit of measurement is not valid')
        .required('The ingredient unit of measurement is required')
    })
  )
});



// WEBPACK FOOTER //
// ./src/validation/lot.js